import { memo, useState, useCallback } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useHasAccountingIntegrationSyncError } from '../hooks/useHasAccountingIntegrationSyncError';
import { getDataSyncFailingToSyncLink } from '../utils/links';
import { getQuickBooksAppId } from '../utils/getIntegrationAppIds';
import ErrorBoundary from './errors/ErrorBoundary';
import { UserAttributeName } from '../constants/UserAttributes';
import { writeHubUserAttribute } from '../utils/hubUserAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
function InvoiceSyncFailureBanner({
  objectType,
  usageTracker
}) {
  const [showInvoiceSyncFailureBanner, setShowInvoiceSyncFailureBanner] = useState(true);

  // TODO: need to figure out how to get xero
  const appId = getQuickBooksAppId();
  const {
    accountId,
    connectionId,
    hasSyncFailureSinceLastHide,
    loading
  } = useHasAccountingIntegrationSyncError({
    appId,
    objectType
  });
  const onClose = useCallback(() => {
    writeHubUserAttribute(UserAttributeName.HasDismissedInvoiceSyncErrorBanner, new Date().getTime().toString());
    usageTracker.track('accountingIntegrationsUsage', {
      action: 'dismissed invoice sync error banner'
    });
    setShowInvoiceSyncFailureBanner(false);
  }, [usageTracker]);
  const onLinkClick = useCallback(() => {
    usageTracker.track('accountingIntegrationsUsage', {
      action: 'navigate to invoice sync failure page'
    });
  }, [usageTracker]);
  if (!accountId || !connectionId || objectType !== INVOICE_TYPE_ID || !hasSyncFailureSinceLastHide || !showInvoiceSyncFailureBanner || loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "invoice-sync-failure-banner",
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoiceSync.failureBanner.titleText"
    }),
    closeable: true,
    onClose: onClose,
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Link, {
      "data-test-id": "invoice-sync-failure-link",
      external: true,
      href: getDataSyncFailingToSyncLink(appId.toString(), accountId.toString(), connectionId.toString()),
      onClick: onLinkClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoiceSync.failureBanner.linkText"
      })
    })
  });
}
const InvoiceSyncFailureBannerWithErrorBoundary = /*#__PURE__*/memo(({
  objectType,
  usageTracker
}) => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: null,
    boundaryName: "invoiceSyncFailureBannerErrorBoundary",
    children: /*#__PURE__*/_jsx(InvoiceSyncFailureBanner, {
      objectType: objectType,
      usageTracker: usageTracker
    })
  });
});
export default InvoiceSyncFailureBannerWithErrorBoundary;